import { ref, toRaw } from 'vue';

import { message } from 'ant-design-vue';

import { useRouter } from 'vue-router';

import Api from '@/api/Api';

import camelCase from 'lodash/camelCase';

import { useBaseStationsStore } from '@/stores/baseStations';
import { useSessionStore } from '@/stores/session';

import { showErrorMessage, getErrorText } from '@/components/common/errorMessage';


export function useFormSubmit(validate, baseStationId, formState, validateInfos, messages, resetChangedState, onSuccessHook, onErrorHook) {
	const isSubmitting = ref(false);
	const router = useRouter();
	const baseStationsStore = useBaseStationsStore();
	const sessionStore = useSessionStore();
	const onSubmit = closeFormAfterSuccess => {
		validate().then(() => {
			isSubmitting.value = true;
			const data = Api.serializeBaseStationAdd(toRaw(formState), baseStationId.value);
			Api.baseStationAdd(data, response => {
				if (response.status === 'ok') {
					message.success(messages.value.successMessage);
					baseStationsStore.baseStationRefreshList();
					if (closeFormAfterSuccess) {
						router.push({ name: sessionStore.closeButtonRoute || 'base-stations' });
					}
					resetChangedState();
					if (!closeFormAfterSuccess && onSuccessHook != null) {
						onSuccessHook();
					}
				} else {
					['label', 'host', 'port', 'mntpnt_int', 'mntpnt_src'].forEach(element => {
						if (response.errors[element]) {
							let jsElement = camelCase(element);
							validateInfos[jsElement].validateStatus = 'error';
							validateInfos[jsElement].help = getErrorText(element, response.errors[element]);
						}
					});
					showErrorMessage(response.errors);
					if (onErrorHook != null) {
						onErrorHook(false);
					}
				}
				isSubmitting.value = false;
			});
		}).catch(err => {
			console.log('error', err);
			if (onErrorHook != null) {
				onErrorHook(true);
			}
		});
	};
	return {
		isSubmitting,
		onSubmit,
	}
}
